import { Instance, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { AdminSubscriberService } from '@services/adminSubscriberService';
import { LanguageService } from '@services/languageService';
import { initTable } from '@utils/collectionSetup';
import { AdminController } from './adminController';

export class AdminSubscribersIndexController extends AdminController {
    static readonly inject = [
        'instances',
        'adminSubscriberService',
        'languageService',
    ] as const;

    private table!: Table;

    constructor(
        instances: Instance,
        private adminSubscriberService: AdminSubscriberService,
        private languageService: LanguageService,
    ) {
        super(instances);
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton('.btn-admin-index', this.dom, () => {
            this.state.goBack('admin.index');
        });

        this.helper.fabButton('.btn-subscribers-new', this.dom, () => {
            this.adminSubscriberService.newDialogByAdmin().then(() => {
                this._drawContent();
            });
        });
    }

    protected override _initTable(): void {
        this.table = initTable(
            this.table,
            this.dom,
            'table',
            this.adminSubscriberService,
            {
                entityKey: 'subscribers',
                fetchData: (params) =>
                    this.adminSubscriberService.getAll(params),
                extraParams: (params) => {
                    params.set('query', this.query);
                },
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (subscriber) => {
                        this.adminSubscriberService
                            .editDialog(subscriber, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const adminSubscribersIndexController = app.controller(
    'adminSubscribersIndexController',
    AdminSubscribersIndexController,
);
